import { apiProxy } from '@/libs/api/apiProxy'
import { BookmarkResponse } from '@/types/bookmark'

export const PostBookmark = (summaryId: number): Promise<BookmarkResponse> => {
  return apiProxy.post<BookmarkResponse>(`/api/bookmark/${summaryId}`)
}

export const DeleteBookmark = (
  summaryId: number
): Promise<BookmarkResponse> => {
  return apiProxy.del<BookmarkResponse>(`/api/bookmark/${summaryId}`)
}
